// extracted by mini-css-extract-plugin
export default {"content":"SpoilerContent_content","title":"SpoilerContent_title"};